import React, { useEffect, useState } from 'react';
import { bgMembers, tableBenefits } from 'assets';
import { Button, Modal, Picture } from 'components/UI';
import PropTypes from 'prop-types';
import {
  membershipBenefits,
  experienceOptions,
} from 'utils/constants';
import { bgAuth } from 'assets';
import { BackgroundSection } from '../../LandingPage/common';
import TierInfoCard from '../../Membership/TierInfoCard';
import ExperienceFilter from '../../Membership/ExperienceFilter';
import MembershipCard from 'containers/Membership/MembershipCard';

const ChooseTiers = ({
  memberTiers = [],
  setLiteOnly,
  liteOnly = false,
  getPrice,
  getMinPrice,
  showNextScreen,
  selectedBillingCycle,
  setSelectedBillingCircle,
}) => {
  const sortedTiers = memberTiers.sort((tier1, tier2) => {
    return getMinPrice(tier1.prices) - getMinPrice(tier2.prices);
  });

  const [activeTab, setActiveTab] = useState(
    experienceOptions[experienceOptions.length - 1]
  );
  const handleTabChange = (experience) => {
    setActiveTab(experience);
    setLiteOnly(experience !== experienceOptions[experienceOptions.length - 1]);
  };

  return (
    <>
      <BackgroundSection
        backgroundImage={`url(${bgAuth.default})`}
        className="relative flex flex-col bg-no-repeat bg-cover pt-24 pb-20 px-2"
      >
        <ExperienceFilter
          handleTabChange={handleTabChange}
          activeTab={activeTab}
          className="text-white"
        />
        <div className="flex flex-col items-center max-w-6xl mx-auto my-12 px-4 relative z-10">
          <div className="mt-5 flex flex-col-reverse space-y-3 md:space-y-0 lg:px-3 justify-center" style={{ gap: '1.5rem' }}>
            {sortedTiers.map((tier) => (
              <MembershipCard
                key={tier.id}
                memberTier={tier?.name}
                selectedPlan={selectedBillingCycle}
                setSelectedPlan={setSelectedBillingCircle}
                monthlyPrice={getPrice(tier, 'month')}
                annualPrice={getPrice(tier, 'year')}
                isAllAccessEligible={!liteOnly}
                showNextScreen={showNextScreen}
                benefits={membershipBenefits[tier?.name]}
              />
            ))}
          </div>
          <div className="flex justify-center mt-6" style={{ gap: '0.25rem' }}>
            <span className="text-white">Still deciding?</span>
            <Modal content={<Picture src={tableBenefits} />} className="bg-black-cover z-50">
              <span className="text-easter cursor-pointer">See a full list of our features</span>
            </Modal>
          </div>
        </div>
      </BackgroundSection>
    </>
  );
};

ChooseTiers.propTypes = {
  memberTiers: PropTypes.array.isRequired,
  setLiteOnly: PropTypes.func.isRequired,
  liteOnly: PropTypes.bool.isRequired,
  getPrice: PropTypes.func.isRequired,
  getMinPrice: PropTypes.func.isRequired,
  showNextScreen: PropTypes.func.isRequired,
};

export default ChooseTiers;
